// Base
import Link from 'next/link'
import { useMemo } from 'react'

// Components
import { Flex, Button } from 'yard-utilities/components'

interface MainButtonProps {
  redirectURL?: string
  onClick?: () => void
  buttonText?: string
  variant?: string
}

const MainButton = ({
  redirectURL,
  onClick,
  buttonText = 'start now',
  variant = 'yellow-sm-shadow'
}: MainButtonProps) => {
  const buttonOptions = useMemo(() => {
    if (redirectURL) {
      return {
        as: Link,
        href: redirectURL
      }
    } else if (onClick) {
      return {
        onClick: onClick
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Flex fullWidth center>
      <Button {...buttonOptions} transform="uppercase" variant={variant}>
        {buttonText}
      </Button>
    </Flex>
  )
}

export default MainButton
